'use client';

import { useEffect } from 'react';

type VideoObjectSchemaInjectorProps = {
  schema: object;
};

/**
 * Client-side component to inject VideoObject schema into the DOM
 * This avoids server-side size limits during hydration
 */
export function VideoObjectSchemaInjector({
  schema,
}: VideoObjectSchemaInjectorProps) {
  useEffect(() => {
    // Create script tag on client side only
    const script = document.createElement('script');
    script.id = 'video-schema';
    script.type = 'application/ld+json';
    script.textContent = JSON.stringify(schema);

    // Check if script already exists (cleanup from previous renders)
    const existing = document.getElementById('video-schema');
    if (existing) {
      existing.remove();
    }

    // Append to head
    document.head.appendChild(script);

    // Cleanup on unmount
    return () => {
      const scriptToRemove = document.getElementById('video-schema');
      if (scriptToRemove) {
        scriptToRemove.remove();
      }
    };
  });

  // Return null - this component doesn't render anything in React tree
  return null;
}
